import type { Experiment } from '@/types/experiment';

export const serializeExperiments = (experiments: Experiment[]): string =>
	experiments.map(({ variant }) => variant).join('|');
